<template>
    <div class="toggle-wrap">
        <div class="toggle">
            <div class="option" :class="{ active: baseSelection === 'c' }" @click="selectOption('c')">C</div>
            <div class="option" :class="{ active: (baseSelection === 'i' || baseSelection === 'ir') }" @click="selectOption('i')">I</div>
            <div class="option" :class="{ active: (baseSelection === 'r' || baseSelection === 'ir') }" @click="selectOption('r')">R</div>
        </div>
        <button type="button" class="q-badge" :class="{ active: hasQ }" @click="selectOption('q')">Q</button>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            selectedOption: this.modelValue
        };
    },
    methods: {
        parseSelection(value) {
            const normalized = (value || '').toLowerCase();
            const hasQ = normalized.includes('q');
            let baseSelection = null;

            if (normalized.includes('i') && normalized.includes('r')) {
                baseSelection = 'ir';
            } else if (normalized.includes('i')) {
                baseSelection = 'i';
            } else if (normalized.includes('r')) {
                baseSelection = 'r';
            } else if (normalized.includes('c')) {
                baseSelection = 'c';
            }

            return { baseSelection, hasQ };
        },
        buildSelection(baseSelection, hasQ) {
            if (!baseSelection) {
                return hasQ ? 'q' : null;
            }

            if (!hasQ) {
                return baseSelection;
            }

            if (baseSelection === 'ir') return 'irq';
            return `${baseSelection}q`;
        },
        selectOption(option) {
            let { baseSelection, hasQ } = this.parseSelection(this.selectedOption);

            if (option === 'q') {
                hasQ = !hasQ;
            } else if (option === 'c') {
                baseSelection = baseSelection === 'c' ? null : 'c';
            } else if (baseSelection === option) {
                baseSelection = null;
            } else if (baseSelection === null) {
                baseSelection = option;
            } else if (baseSelection === 'i' || baseSelection === 'r') {
                baseSelection = 'ir';
            } else if (baseSelection === 'c') {
                baseSelection = option;
            } else {
                baseSelection = option === 'i' ? 'r' : 'i';
            }

            this.selectedOption = this.buildSelection(baseSelection, hasQ);
            this.$emit('update:modelValue', this.selectedOption);
        }
    },
    watch: {    
        modelValue(newValue) {
            this.selectedOption = newValue;
        }
    },
    computed: {
        parsedSelection() {
            return this.parseSelection(this.selectedOption);
        },
        baseSelection() {
            return this.parsedSelection.baseSelection;
        },
        hasQ() {
            return this.parsedSelection.hasQ;
        }
    }
};
</script>

<style scoped>
.toggle-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
}

.toggle {
    display: flex;
    justify-content: space-between;
    width: 76px;
    border: 1px solid #3F8FB2;
    border-radius: 10px;
    overflow: hidden;
}

.option {
    flex: 1;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    background-color: white;
    color: #3F8FB2;
    border-right: 1px solid #3F8FB2;
    transition: background-color 0.3s ease;
}

.option:last-child {
    border-right: none;
}

.option.active {
    background-color: #4AA7D0;
    background-image: linear-gradient(to bottom, #4AA7D0, #357A96);
    color: white;
}

.q-badge {
    width: 30px;
    height: 30px;
    border: 1px solid #3F8FB2;
    border-radius: 9999px;
    background: white;
    color: #3F8FB2;
    font-weight: 700;
    cursor: pointer;
    line-height: 1;
}

.q-badge.active {
    background-color: #4AA7D0;
    background-image: linear-gradient(to bottom, #4AA7D0, #357A96);
    color: white;
    border-color: #357A96;
}
</style>
